export { doRegister, dismissDoRegisterError } from './doRegister';



// WEBPACK FOOTER //
// ./src/features/register/redux/actions.js